import { render, staticRenderFns } from "./ChatNote.vue?vue&type=template&id=40a6376a&"
import script from "./ChatNote.vue?vue&type=script&lang=js&"
export * from "./ChatNote.vue?vue&type=script&lang=js&"
import style0 from "./ChatNote.vue?vue&type=style&index=0&id=40a6376a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports